import { render, staticRenderFns } from "./compExceptionList.vue?vue&type=template&id=471e7e60&"
import script from "./compExceptionList.vue?vue&type=script&lang=js&"
export * from "./compExceptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports